export default __webpack_public_path__ + "static/our-product-paircare-7ea22f32352e1c3fb315d8c70ae1bec8.png";